<template>
  <v-btn
    v-bind="activatorProps"
    :icon="iconName"
    size="30"
    :text="title"
    class="ma-1"
    variant="outlined"
    @click="isActive = true"
  ></v-btn>
  <v-dialog max-width="900" v-model="isActive">
    <v-card :title="title">
      <v-sheet class="mx-auto" width="800">
        <SimpleDataTable
          :items="customerGroups"
          :headers="groupsHeaders"
        ></SimpleDataTable>
      </v-sheet>

      <v-card-actions>
        <v-spacer></v-spacer>
        <DialogCustGroupsAddRemove
          :v-model="dialogGroupsAddRemove"
          iconName="mdi-plus"
          :customer="customer"
          :groups="availableGroups"
          mode="add"
          @closed="refreshGroups"
        />
        <DialogCustGroupsAddRemove
          :v-model="dialogGroupsAddRemove"
          iconName="mdi-minus"
          :customer="customer"
          :groups="customerGroups"
          mode="remove"
        />
        <!-- <v-btn text="حفظ" @click="save"></v-btn> -->
        <v-btn text="إغلاق" @click="close"></v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import DialogCustGroupsAddRemove from "@/components/dialogs/DialogCustGroupsAddRemove.vue";
import SimpleDataTable from "@/components/common/SimpleDataTable.vue";
import repo from "@/store/repo.js";
export default {
  components: {
    DialogCustGroupsAddRemove,
    SimpleDataTable,
  },
  props: ["customer", "groups", "iconName"],
  data() {
    return {
      dialogGroupsAddRemove: false,
      isActive: false,
      groupsHeaders: [
        { title: "الاسم", key: "name" },
        { title: "الوصف", key: "description" },
        { title: "معفى من القطع", key: "isNoCut" },
        { title: "له خصم", key: "isDiscount" },
        { title: "قيمة الخصم", key: "discount" },
      ],
    };
  },
  methods: {
    close() {
      this.isActive = false;
    },
    refreshGroups() {
      // let cg = repo.customers.getCustomerGroups(this.customer.id);
      // console.log("cg event", cg);
    },
  },
  watch: {
    isActive(value) {
      if (value) {
        //console.log(value);
      }
    },
  },
  computed: {
    customerGroups() {
      const cg = repo.customers.getCustomerGroups(this.customer.id);
      console.log("cg", cg);
      return cg;
    },
    availableGroups() {
      let x = this.groups.filter((g) => {
        return !this.customer.groups.map((x) => x.id).includes(g.id);
      });
      let y = this.customer.groups.filter((x) => x.deleted_at == null);
      return [...x, ...y];
    },
  },
};
</script>
